import React, { useEffect, useRef, useState } from 'react';
import './IncidentCyber.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import ContactSection from '../../components/HomePage/ContactSectionHome/ContactSectionHome';
import ScrollingLogos from '../../components/Common/ScrollingLogos/ScrollingLogos';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ExpertiseSection from '../../components/CyberIncident/ExpertiseSectionCyberData/ExpertiseSectionCyberData';
import useSectionRefs from '../../hooks/useSectionRefs';
import IntroSectionCyberIncident from '../../components/CyberIncident/IntroSectionCyberIncident/IntroSectionCyberIncident';
import IntroSectionCyberIncident2 from '../../components/CyberIncident/IntroSectionCyberIncident/IntroSectionCyberIncident2';
import IntroSectionCyberIncident3 from '../../components/CyberIncident/IntroSectionCyberIncident/IntroSectionCyberIncident3';
import introSectionData8 from '../../components/Common/IntroSectionBottom/introSectionData8';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import BenefitsPrivateCloud from '../../components/CyberIncident/ServicesSliderCyberIncident/Benefits';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelinePrivateCloud from '../../components/CyberIncident/Timeline/TimelinePrivateCloud';
import { useTranslation } from 'react-i18next';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureIncidentCyber from '../../components/ui/pricing-section-azure-incidentcyber';

const IncidentCyber: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();

  
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header title={t('incidentCyber.header.title', 'Réponse aux incidents cyber')} subtitle={t('incidentCyber.header.subtitle', 'Votre soutien pour la gestion de crise')} />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionCyberIncident />
      </section>

      <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionCyberIncident3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionCyberIncident2 />
      </section>

      <section id="services" className="section light" ref={sectionRefs.services}>
        <IntroSectionBottom data={introSectionData8} translationNamespace="incidentCyber" />
      </section>
        <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureIncidentCyber openContactModal={handleOpenContactModal} />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
        <TimelinePrivateCloud />
        <GridPatternCard>
          <GridPatternCardBody>
            <div className="tw-h-[5em]">
            </div>
          </GridPatternCardBody>
        </GridPatternCard>
            </section>
          </div>
        </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="incidentCyber" />
       <Footer />
      </section>
    </div>
    </div>
  );
};

export default IncidentCyber;
